import { render, staticRenderFns } from "./WorkClientContactTableItem.vue?vue&type=template&id=912bda2c&scoped=true&"
import script from "./WorkClientContactTableItem.vue?vue&type=script&lang=js&"
export * from "./WorkClientContactTableItem.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientContactTableItem.vue?vue&type=style&index=0&id=912bda2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912bda2c",
  null
  
)

export default component.exports